import { StorefrontCountry } from "src/types/storefront"

const de = {
  summary: "Zusammenfassung",
  subtotal: "Zwischensumme",
  discount: "Rabatt",
  giftCard: "Geschenkkarte",
  format_shipping: (country: StorefrontCountry | undefined) => (country ? "Versand nach " + country.name : "Versand"),
  total: "Gesamtsumme",
  freeShipping: "kostenlos",
  noShipping: "entfällt",
  willBeCalculatedAtCheckout: "wird an der Kasse berechnet",
  format_taxLine: (taxTotal: string) => `inkl. MwSt. (${taxTotal})`,
}

const en: typeof de = {
  summary: "Summary",
  subtotal: "Subtotal",
  discount: "Discount",
  giftCard: "Gift card",
  format_shipping: (country) => (country ? "Shipping to " + country.name : "Shipping"),
  total: "Total",
  freeShipping: "free",
  noShipping: "None",
  willBeCalculatedAtCheckout: "will be calculated at checkout",
  format_taxLine: (taxTotal) => `incl. VAT (${taxTotal})`,
}

export const totalsText = { de, en }
